import { ComponentProps } from 'react'

import { BlockIcon } from '@/components/icons/block-icon'

export const CloseIcon = (props: Omit<ComponentProps<typeof BlockIcon>, 'icon'>) => {
	return (
		<svg cursor="pointer" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				d="M18 6L6 18M6 6L18 18"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
